const messages = {
  "ui.popconfirm.footer.cancelText": "Cancel",
  "ui.popconfirm.footer.okText": "OK",
  "ui.popconfirm.title": "Are you sure?",
} as const;

export default messages;
